import { Controller } from "@hotwired/stimulus"

// Ricarica la pagina a intervalli finché l'elemento che monta il controller
// resta in pagina.
//
// Il timer si ri-arma SEMPRE dopo ogni tentativo, non in connect(): il layout
// usa `turbo-refresh-method: morph`, quindi una visita alla stessa URL fonde il
// DOM invece di ricostruirlo e Stimulus non richiama connect(). Ri-armare solo
// alla connessione faceva un unico giro e poi silenzio, lasciando la pagina
// ferma sullo stato di attesa.
//
// La condizione di uscita è disconnect(): quando lo stato cambia, il blocco che
// monta il controller non viene più reso, l'elemento sparisce e il timer muore.
export default class extends Controller {
  static values = { url: String, interval: { type: Number, default: 3000 } }

  connect() {
    this.poll()
  }

  disconnect() {
    this.stopped = true
    clearTimeout(this.timeout)
  }

  poll() {
    if (this.stopped) return

    this.timeout = setTimeout(() => {
      // Il fetch è solo un controllo di raggiungibilità: se il server non
      // risponde si riprova al giro dopo, senza far vedere una pagina di errore.
      fetch(this.urlValue, { headers: { Accept: "text/html" } })
        .then(() => {
          if (!this.stopped) Turbo.visit(this.urlValue, { action: "replace" })
        })
        .catch(() => {})
        .then(() => this.poll())
    }, this.intervalValue)
  }
}
